export const TIER_FEATURES = [
  {
    name: "Free",
    sub_tier: 0,
    features: [
      {
        feature_description: "<b>250MB</b> of Storage (5 Wheel limit)",
        tooltip: false,
      },
      {
        feature_description: "5 Clone limit",
        tooltip: false,
      },
      {
        feature_description: "1 AI Wheel Token <b>(Monthly)</b>",
        tooltip:
          "Build Wheels from a simple Prompt. An average Wheel takes 8 tokens",
      },
      { feature_description: "Basic Wheel Building features", tooltip: false },
      { feature_description: "Basic Locks", tooltip: false },
      // { feature_description: "No Revenue Generating features", tooltip: false },
    ],
  },
  {
    name: "Essential",
    sub_tier: 1,
    features: [
      {
        feature_description: "<b>500MB</b> of Storage (~20 Wheels/Clones)",
        tooltip: false,
      },

      {
        feature_description: "10 AI Wheel Tokens <b>(Monthly)</b>",
        tooltip:
          "Build Wheels from a simple Prompt. An average Wheel takes 8 tokens",
      },
      {
        feature_description: "AI Color Generator",
        tooltip:
          "With a simple prompt or image, our generator will design a color theme for your Wheel.",
      },
      { feature_description: "Basic Locks", tooltip: false },
      // { feature_description: "No Revenue Generating features", tooltip: false },
    ],
  },
  {
    name: "Premium",
    sub_tier: 2,
    features: [
      {
        feature_description: "<b>2GBs</b> of Storage (~ 80 Wheels/Clones)",
        tooltip: false,
      },
      {
        feature_description: "50 AI Wheel Tokens <b>(Monthly)</b>",
        tooltip:
          "Build Wheels from a simple Prompt. An average Wheel takes 8 tokens",
      },
      {
        feature_description: "AI Color Generator",
        tooltip:
          "With a simple prompt or image, our generator will design a color theme for your Wheel.",
      },
      { feature_description: "Basic Locks", tooltip: false },
      {
        feature_description: "Paid Locks",
        tooltip: "Charge guests to access your Wheels.",
      },
      // {
      //   feature_description: "Referral Revenue",
      //   tooltip:
      //     "Earn commissions for referring new subscribers. Commission % is based on your subscription level. Premium - 5% ProSuite - 10%",
      // },
      {
        feature_description: "Customizable Ad Space (1)",
        tooltip: "Let your Business Box showcase your products & services",
      },
    ],
  },
  {
    name: "ProSuite",
    sub_tier: 3,
    features: [
      {
        feature_description: "<b>8GBs</b> of Storage (~ 320 Wheels/Clones)",
        tooltip: false,
      },
      {
        feature_description: "200 AI Wheel Tokens <b>(Monthly)</b>",
        tooltip:
          "Build Wheels from a simple Prompt. An average Wheel takes 8 tokens",
      },
      {
        feature_description: "AI Color Generator",
        tooltip:
          "With a simple prompt or image, our generator will design a color theme for your Wheel.",
      },
      {
        feature_description: "Paid Locks",
        tooltip: "Charge guests to access your Wheels.",
      },
      // {
      //   feature_description: "Referral Revenue",
      //   tooltip:
      //     "Earn commissions for referring new subscribers. Commission % is based on your subscription level. Premium - 5% ProSuite - 10%",
      // },
      {
        feature_description: "Customizable Ad Space (Unlimited)",
        tooltip: "Let your Business Box showcase your products & services",
      },
    ],
  },
  // PLQA-C-002: Business (sub_tier 4) has no admin-entered feature list yet
  // (server `feature_splits` is empty), so without an entry here
  // `resolveCardFeatures` (subscriptionCardFeatures.js) returned an empty
  // array and the card rendered with zero checkmarks. This single honest
  // placeholder line — not a fabricated feature list — is ONLY a rendering
  // fallback for the "nothing configured yet" state; it is not a claim about
  // what Business will eventually include.
  {
    name: "Business",
    sub_tier: 4,
    features: [
      {
        feature_description: "Business plan features are being finalized",
        tooltip: false,
      },
    ],
  },
];

/**
 * PLQA-C-002: a paid tier (sub_tier > 0) can reach the client fully
 * unconfigured for self-serve purchase -- no Stripe product linked yet
 * (`stripe_product_id` null/falsy) and a $0 placeholder price. That $0 is a
 * "not priced yet" signal from the server, NOT "this tier is free forever"
 * -- rendering it as "Free" (the same label the real, permanently-free
 * sub_tier 0 gets) directly contradicts marketing copy that promises
 * per-seat billing. This is the single place that decides which of the two
 * a given item is, so the price label / feature list / CTA can't drift out
 * of sync with each other again (see SubscriptionItem.jsx).
 *
 * stgqa-0927-P0-kelly-gate-d-r100217: a SEPARATE unpriced case the above
 * alone never caught -- a tier WITH a real `stripe_product_id` whose live
 * Stripe `Price.retrieve()` lookup failed (catalog configured, price lookup
 * down). The backend already signals this per-row via
 * `price.price_unavailable` (subscription/serializers.py::get_price_unavailable,
 * added for the matching stgqa-0925-u14 "Free/$0 on a Stripe outage" bug)
 * specifically so the FE renders "Coming Soon" instead of a misleading
 * "Free" here -- this file just never read that field, so every paid tier
 * silently fell through to the isFreeTier branch below whenever Stripe
 * price lookups were failing, live-reproduced on web-stg.iyuga.net
 * (Essential/Premium/ProSuite/Business all showed "Free" under both
 * Monthly and Annual, GET /subscription/packages/ returning
 * price.price_unavailable:true for all four with real stripe_product_ids).
 *
 * @param {Object} args
 * @param {number} args.subTier
 * @param {number|string} args.perMonthCost
 * @param {string|null|undefined} args.stripeProductId
 * @param {boolean} [args.priceUnavailable]
 * @returns {boolean}
 */
export function isUnpricedPaidTier({ subTier, perMonthCost, stripeProductId, priceUnavailable } = {}) {
  return (
    typeof subTier === "number" &&
    subTier > 0 &&
    parseFloat(perMonthCost) === 0 &&
    (!stripeProductId || !!priceUnavailable)
  );
}
